import { useDispatch, useSelector } from "react-redux";
import { setDarkMode } from "../store/themeSlice";
import { scrollToId } from "../utils/scrollToId";
import { useTranslation } from "react-i18next";
import { useState, useRef, useEffect } from "react";
import { NavbarStyle } from "./NavbarStyle";

const LANGUAGES = [
  { code: "ja", label: "日本語", flag: "img/flags/japan.svg", alt: "japan" },
  { code: "en", label: "English", flag: "img/flags/uk.svg", alt: "uk" },
  { code: "se", label: "Svenska", flag: "img/flags/se.svg", alt: "sweden" },
];

export default function Navbar() {
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();
  const darkMode = useSelector((state) => state.theme.darkMode);
  const setLanguageHandler = (lng) => {
    i18n.changeLanguage(lng);
    try {
      localStorage.setItem("language", lng);
    } catch (error) {
      console.log(error);
    }
  };
  const setDarkModeHandler = (dark) => {
    dispatch(setDarkMode(dark));
    localStorage.setItem("darkMode", JSON.stringify(dark));
  };

  const [languageMenuOpen, setLanguageMenuOpen] = useState(false);
  const languageMenuRef = useRef(null);
  const languageButtonRef = useRef(null);

  useEffect(() => {
    if (!languageMenuOpen) return;
    const handleClickOutside = (event) => {
      if (
        languageMenuRef.current &&
        !languageMenuRef.current.contains(event.target)
      ) {
        setLanguageMenuOpen(false);
      }
    };
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setLanguageMenuOpen(false);
        languageButtonRef.current?.focus();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [languageMenuOpen]);
  return (
    <NavbarStyle className={darkMode ? "dark" : ""}>
      <ul>
        <li>
          <a
            href="#portfolio-section"
            onClick={(e) => {
              e.preventDefault();
              scrollToId("portfolio-section");
            }}
          >
            {t("portfolio")}
          </a>
        </li>
        <li>
          <a
            href="#it-jobs-section"
            onClick={(e) => {
              e.preventDefault();
              scrollToId("it-jobs-section");
            }}
          >
            {t("itJobs")}
          </a>
        </li>
        <li>
          <a
            href="https://github.com/phminella"
            target="_blank"
            rel="noreferrer"
            aria-label="View GitHub profile"
          >
            <img
              className="nav-github"
              src="img/icon-github.svg"
              alt="git"
              loading="lazy"
            />
          </a>
        </li>
      </ul>
      <ul>
        <li className="language-switcher" ref={languageMenuRef}>
          <button
            ref={languageButtonRef}
            className="language-button"
            aria-haspopup="true"
            aria-expanded={languageMenuOpen}
            aria-label="Change language"
            onClick={() => setLanguageMenuOpen((open) => !open)}
          >
            <span className="language-label">
              {LANGUAGES.find((lng) => lng.code === i18n.language)?.label ??
                LANGUAGES[1].label}
            </span>{" "}
            <img
              alt=""
              src={
                LANGUAGES.find((lng) => lng.code === i18n.language)?.flag ??
                LANGUAGES[1].flag
              }
              loading="lazy"
            />
          </button>
          {languageMenuOpen && (
            <ul className="language-menu" role="menu">
              {LANGUAGES.map((lng) => (
                <li key={lng.code} role="none">
                  <button
                    role="menuitem"
                    aria-current={i18n.language === lng.code}
                    className={i18n.language === lng.code ? "active" : ""}
                    onClick={() => {
                      if (i18n.language !== lng.code) {
                        setLanguageHandler(lng.code);
                      }
                      setLanguageMenuOpen(false);
                      languageButtonRef.current?.focus();
                    }}
                  >
                    <img alt="" src={lng.flag} loading="lazy" />
                    <span>{lng.label}</span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </li>
        <li className="dark-mode">
          {!darkMode ? (
            <button
              style={{ fontSize: "1.3rem" }}
              onClick={() => setDarkModeHandler(!darkMode)}
              aria-label="Switch to dark mode"
            >
              <img src="img/icon-moon.svg" alt="" loading="lazy" />
            </button>
          ) : (
            <button
              className="dark-mode-sun"
              style={{ fontSize: "1.3rem" }}
              onClick={() => setDarkModeHandler(!darkMode)}
              aria-label="Switch to light mode"
            >
              &#128261;
            </button>
          )}
        </li>
      </ul>
    </NavbarStyle>
  );
}